<div class="layoutBlock">
    <div class="columnFull">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts' | hisUi}}"
            [toggleable]="false">

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts.fullReimbursementCosts"
                    [(ngModel)]="reimbursementCosts.fullReimbursement" type="checkbox"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam
                label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts.travelAllowanceAmount' | hisUi}}">
                <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                    [(ngModel)]="reimbursementCosts.travelAllowanceAmount"
                    (ngModelChange)="onModelChange($event)"></p-inputNumber>
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts.foregoDailyAllowance"
                    [(ngModel)]="reimbursementCosts.foregoDailyAllowance" type="checkbox"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts.foregoAccommodationAllowance"
                    [(ngModel)]="reimbursementCosts.foregoAccommodationAllowance" type="checkbox"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts.foregoTravelCosts"
                    [(ngModel)]="reimbursementCosts.foregoTravelCosts" type="checkbox"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts.foregoParticipationFees"
                    [(ngModel)]="reimbursementCosts.foregoParticipationFees" type="checkbox"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam
                helptext="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts.accidentCare.helptext">
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts.accidentCare"
                    [(ngModel)]="reimbursementCosts.accidentCare" type="checkbox"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts.provideCompensationAmount"
                    [(ngModel)]="reimbursementCosts.provideCompensationAmount" type="checkbox"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

        </p-panel>
    </div>
</div>